<script lang="ts">
	import { Dots } from '@Shelly/shelly-design-system';
	import { mappedInputReaderEvent } from 'src/helpers/input_reader_helpers';
	import type { DotsPropsTypes } from '@Shelly/shelly-design-system';
	let className = '';
	export { className as class };
	export let event;
	export let shrinkOnMobile: DotsPropsTypes['shrinkOnMobile'] = false;
	export let color: DotsPropsTypes['color'] = 'default';
</script>

<Dots class={className} type={mappedInputReaderEvent[event]} {color} {shrinkOnMobile} />
